const MIXPANEL_CAC_LOAD_EVENT_NAME = "CAC: GOTV CAC Opened";
const MIXPANEL_CAC_INTERACT_EVENT_NAME = "CAC: GOTV CAC Interaction";

export default {
  MIXPANEL_CAC_LOAD_EVENT_NAME,
  MIXPANEL_CAC_INTERACT_EVENT_NAME
}
